import React from "react";
import "./project.scss";

export const Project = () => {
  return (
    <div className="project" id="project">
      <div className="wrapper">
        <h1>About Me</h1>
        <div className="desc">
          <div>
            Hello everyone, I am Ankit Nayan, a programmer, developer, and
            gamer. I am a Full stack web developer and love to make real-world
            web applications such as food ordering app or a shopping app. I
            usually use "MERN" for my development which is Mongo, Express,React,
            and Node.
          </div>
          <div>
            I also solve competitive programing questions on gfg and leetcode
            which help me in improving my programing skills as in competitive
            programing scenario we have to solve a problem in an optimized way.
            I also have knowledge of Data Structure and Algorithm which helps me
            in understanding how a software is working and how it was made.
          </div>
          <div>
            Along with web development, I also do blockchain development which
            is creating a smart contract and storing it on the blockchain. In my
            blockchain journey, i made various smart contracts like minting nft,
            defi, daos etc. Blockchain is a fast-growing space and it can take
            over the web in the future.
          </div>
          <div>
            At last, I would like to talk about myself as a person. I am a very
            hardworking, curious person who loves to learn new technology. My
            hobbies are playing football, table tennis, and video games. Time
            management is my best skill and my strength.
          </div>
        </div>
      </div>
    </div>
  );
};
